import { Component, Input, OnInit } from '@angular/core';
import { GlobalConstants } from 'functions/src/shared/global-constants';
import { MyStatService } from 'src/services/stat/stat.service';

@Component({
  selector: 'app-stats-card',
  templateUrl: './stats-card.component.html',
  styleUrls: ['./stats-card.component.scss']
})
export class StatsCardComponent  {

  public GLOBAL = new GlobalConstants();

  // @Input()
  // stats: MyStatService;


  constructor(public stats: MyStatService) { }

}
